import axios, { AxiosInstance, AxiosRequestConfig, ResponseType } from 'axios';
import { acquireAccessToken } from 'services/authentication/service';

import { HttpMethod } from './types';

const API_BASE_URL =
  (import.meta.env.MODE !== 'development' ? '' : (import.meta.env.VITE_API_BASE_URL ?? '')) +
  '/api';

const UNAUTHENTICATED_API_PREFIX = '/unauthenticated';
const UNAUTHENTICATED_API_URL = API_BASE_URL + UNAUTHENTICATED_API_PREFIX;

class Client {
  baseUrl: string;
  client: AxiosInstance;
  isAuthenticated: boolean;

  constructor(baseUrl: string, isAuthenticated: boolean) {
    this.baseUrl = baseUrl;
    this.isAuthenticated = isAuthenticated;
    this.client = axios.create({ baseURL: this.baseUrl });
  }

  async request<DataType>(
    method: HttpMethod,
    endpoint: string,
    data: Record<string, unknown> | null = null,
    responseType?: ResponseType,
  ) {
    const axiosConfig: AxiosRequestConfig = {
      method,
      url: endpoint,
      responseType,
    };

    if (this.isAuthenticated) {
      const accessToken = await acquireAccessToken();
      axiosConfig.headers = {
        Authorization: 'Bearer ' + accessToken,
      };
    }

    if (['POST', 'PUT', 'PATCH'].includes(method) && data) {
      axiosConfig.data = data;
    }

    const { data: response } = await this.client.request<DataType>(axiosConfig);
    return response;
  }
}

export const apiClient = new Client(API_BASE_URL, true);
export const unauthenticatedApiClient = new Client(UNAUTHENTICATED_API_URL, false);
